import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectAttachment } from "../../utils/types/models";

export default createEntityReducer<IProjectAttachment>(Endpoint.ProjectAttachments, Endpoint.ProjectAttachmentsList);
